module.exports = __webpack_public_path__ + "assets/img/icon1.a5c431b4.png";